import React, { memo } from 'react';
export const ForWhoSection = memo(function ForWhoSection() {
  const avatars = [{
    icon: '📱',
    title: 'Tu celular te roba horas y lo sabés pero no podés parar',
    desc: 'No es falta de voluntad. Es química cerebral alterada por diseño. El Megapack te da el sistema para romper el ciclo desde hoy.'
  }, {
    icon: '💸',
    title: 'Tenés proyectos que llevan meses parados sin avanzar',
    desc: 'El tiempo existe. El problema es que tu atención fue secuestrada. Recuperala con protocolos técnicos reales.'
  }, {
    icon: '😰',
    title: 'Intentaste mil veces ser más disciplinado y siempre fallaste',
    desc: 'La disciplina sola no alcanza cuando el entorno está diseñado para distraerte. El sistema cambia el entorno primero.'
  }, {
    icon: '💡',
    title: 'Sabés que tenés más potencial del que estás materializando',
    desc: 'El talento está. Las ideas están. Lo que falta es el sistema para convertirlos en resultados concretos y medibles.'
  }];
  return <section className="py-10 px-4 bg-gray-50 border-t border-gray-200" data-id="element-192">
      <div className="max-w-2xl mx-auto" data-id="element-193">
        {/* Header */}
        <h2 className="text-[22px] md:text-3xl font-black text-gray-900 text-center mb-6 leading-tight" data-id="element-194">
          Este Megapack{' '}
          <span className="text-yellow-500" data-id="element-195">es para vos si...</span>
        </h2>

        {/* Lista */}
        <div className="space-y-3" data-id="element-196">
          {avatars.map((avatar, index) => <div key={index} className="flex items-start gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 hover:border-yellow-300 transition-colors shadow-sm" data-id="element-197">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-198">
                {avatar.icon}
              </span>
              <div data-id="element-199">
                <p className="text-gray-900 font-black text-[13px] md:text-sm leading-snug" data-id="element-200">
                  {avatar.title}
                </p>
                <p className="text-gray-600 text-[11px] md:text-xs leading-relaxed mt-1" data-id="element-201">
                  {avatar.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});